import { createContext, useContext, ReactNode } from "react";
import { useDriverLocation } from "@/hooks/useDriverLocation";

interface DriverLocation {
  lat: number;
  lng: number;
  accuracy?: number;
  speed?: number;
  heading?: number;
}

interface DriverLocationContextType {
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
  currentLocation: DriverLocation | null;
  isTracking: boolean;
  error: string | null;
  startTracking: () => void;
  stopTracking: () => void;
  updateLocationManually: (lat: number, lng: number) => Promise<void>;
}

const DriverLocationContext = createContext<DriverLocationContextType | null>(null);

export const DriverLocationProvider = ({ children }: { children: ReactNode }) => {
  const locationData = useDriverLocation();
  
  return (
    <DriverLocationContext.Provider value={locationData}>
      {children}
    </DriverLocationContext.Provider>
  );
};

export const useDriverLocationContext = (): DriverLocationContextType => {
  const context = useContext(DriverLocationContext);
  if (!context) {
    throw new Error("useDriverLocationContext must be used within a DriverLocationProvider");
  }
  return context;
};
